<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  export default {
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    watch: {

    },
    computed: {
      
    },
    mounted () {
      
    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: 'post?post_type=news',

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Judul',
              width: '200px',
              value: 'post_title',
              freeze: false,
              hide: false
            },
            {
              text: 'Kategori',
              width: '200px',
              value: 'post_cat_title',
              freeze: false,
              hide: false
            },
            {
              text: 'Dibuat Oleh',
              width: '150px',
              value: 'post_extra',
              freeze: false,
              hide: false,
              format: 'object'
            },
            {
              text: 'Tanggal',
              width: '150px',
              value: 'post_create_datetime',
              freeze: false,
              hide: false,
              format: 'datetime'
            },
            {
              text: 'Status',
              width: '100px',
              value: 'post_status',
              freeze: false,
              hide: false
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // CONFIG PARSING FORM
          form: [],

          // PREFIX KEY
          prefix: 'post_',

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: true,
              api: '',
              window: true,
              href: '/news/form/add'
            },
            edit: {
              button: true,
              api: '',
              window: true,
              href: '/news/form/edit'
            },
            delete: {
              button: false,
              api: ''
            },
            detail: {
              button: true,
              api: '/news/'
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: false,
              api: ''
            },
            hide: {
              button: false,
              api: ''
            }
          }
        }
      }
    }
  }
</script>